var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "pb-10" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            hasData: !!_vm.companyObj,
            loading: _vm.$apollo.queries.companyFromDb.loading,
          },
        },
        [
          [
            _c("ValidationObserver", {
              staticClass:
                "bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 my-4 mb-10 block",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ invalid, handleSubmit }) {
                    return [
                      _c("div", { staticClass: "flex" }, [
                        _c("div", { staticClass: "w-3/12" }, [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "text-lg font-medium leading-6 text-gray-900",
                            },
                            [_vm._v("Company Information")]
                          ),
                          _c(
                            "p",
                            {
                              staticClass:
                                "mt-1 text-sm leading-5 text-gray-500",
                            },
                            [_vm._v("Make changes to your company detail")]
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "w-9/12 ml-20" },
                          [
                            _c("FormPhoto", {
                              staticClass: "max-w-sm",
                              attrs: { labelText: "Company logo" },
                              model: {
                                value: _vm.companyObj.company_logo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.companyObj, "company_logo", $$v)
                                },
                                expression: "companyObj.company_logo",
                              },
                            }),
                            _c("ValidationProvider", {
                              attrs: {
                                rules: "required_field",
                                name: "Business Name",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("FormGroup", {
                                          staticClass: "mt-4",
                                          attrs: {
                                            name: "business_name",
                                            title: "Business Name*",
                                            placeholder: "Enter business name",
                                            errors: errors,
                                          },
                                          model: {
                                            value: _vm.companyObj.business_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.companyObj,
                                                "business_name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "companyObj.business_name",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("ValidationProvider", {
                              attrs: { name: "Country", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "FormGroup",
                                          {
                                            attrs: {
                                              title: "Country*",
                                              errors: errors,
                                            },
                                          },
                                          [
                                            _c("ProfileCountrySelect", {
                                              model: {
                                                value: _vm.country,
                                                callback: function ($$v) {
                                                  _vm.country = $$v
                                                },
                                                expression: "country",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "mt-4 flex w-full justify-between",
                              },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "flex-1 mr-2",
                                  attrs: {
                                    name: "State",
                                    rules: _vm.stateValidationRules,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("RegionInput", {
                                              attrs: {
                                                countries: _vm.country,
                                                errors: errors,
                                              },
                                              model: {
                                                value: _vm.state,
                                                callback: function ($$v) {
                                                  _vm.state = $$v
                                                },
                                                expression: "state",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c("FormGroup", {
                                  staticClass: "flex-1",
                                  attrs: {
                                    name: "postal_code",
                                    title: "Postal / Zip Code",
                                    placeholder: "Enter postal / zip code",
                                  },
                                  model: {
                                    value: _vm.companyObj.postal_code,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.companyObj,
                                        "postal_code",
                                        $$v
                                      )
                                    },
                                    expression: "companyObj.postal_code",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("ValidationProvider", {
                              attrs: {
                                rules: "required|name_with_specific_symbols",
                                name: "City",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("FormGroup", {
                                          attrs: {
                                            errors: errors,
                                            title: "City*",
                                            placeholder: "Enter city",
                                          },
                                          model: {
                                            value: _vm.companyObj.city,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.companyObj,
                                                "city",
                                                $$v
                                              )
                                            },
                                            expression: "companyObj.city",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c(
                              "FormGroup",
                              {
                                attrs: {
                                  name: "address_1_2",
                                  title: "Street Address",
                                },
                              },
                              [
                                _c("FormInput", {
                                  attrs: {
                                    placeholder: "Street and number",
                                    name: "address_1",
                                  },
                                  model: {
                                    value: _vm.companyObj.address1,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.companyObj, "address1", $$v)
                                    },
                                    expression: "companyObj.address1",
                                  },
                                }),
                                _c("FormInput", {
                                  staticClass: "mt-4",
                                  attrs: {
                                    placeholder:
                                      "Apartment, suite, floor, building, etc",
                                    name: "address_2",
                                  },
                                  model: {
                                    value: _vm.companyObj.address2,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.companyObj, "address2", $$v)
                                    },
                                    expression: "companyObj.address2",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("FormGroup", {
                              attrs: {
                                name: "phone_number",
                                title: "Phone Number",
                                placeholder: "Enter phone number",
                              },
                              model: {
                                value: _vm.companyObj.phone_number,
                                callback: function ($$v) {
                                  _vm.$set(_vm.companyObj, "phone_number", $$v)
                                },
                                expression: "companyObj.phone_number",
                              },
                            }),
                            _c("FormGroup", {
                              attrs: {
                                name: "number_of_employees",
                                title: "Number of Employees",
                                placeholder: "Enter number of employees",
                              },
                              model: {
                                value: _vm.companyObj.number_of_employee,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.companyObj,
                                    "number_of_employee",
                                    $$v
                                  )
                                },
                                expression: "companyObj.number_of_employee",
                              },
                            }),
                            _c("ValidationProvider", {
                              attrs: { rules: "url" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("FormGroup", {
                                          attrs: {
                                            name: "website",
                                            title: "Website",
                                            placeholder:
                                              "Enter the URL of your website",
                                            errors: errors,
                                          },
                                          model: {
                                            value: _vm.companyObj.website,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.companyObj,
                                                "website",
                                                $$v
                                              )
                                            },
                                            expression: "companyObj.website",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c(
                              "FormGroup",
                              {
                                staticClass: "mt-4",
                                attrs: { title: "Description" },
                              },
                              [
                                _c("FormTextarea", {
                                  attrs: {
                                    name: "description",
                                    placeholder: "Describe your company",
                                    rows: 10,
                                  },
                                  model: {
                                    value: _vm.companyObj.description,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.companyObj,
                                        "description",
                                        $$v
                                      )
                                    },
                                    expression: "companyObj.description",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "h-12" },
                        [
                          _c("UiButton", {
                            staticClass: "float-right inline-block",
                            attrs: {
                              buttonText: "Update",
                              id: "updateCompany",
                              processing: _vm.processing,
                              disabled: invalid,
                            },
                            on: {
                              click: function ($event) {
                                return handleSubmit(_vm.onSubmit)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }